
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/Users/mauriciomateus/sites/ipa-lms/sentry.client.config.ts")
            }
          });